import React, { FC, useState, useEffect, ReactNode, ReactElement } from "react";
import injectSheet from "react-jss";
import classNames from "classnames";
import styleSheet from "./styles";
import { Funnel, Arrow } from "./Components";
import { SideBarContent } from "./SideBarContent";
import { MainContent } from "./MainContent";
import SimpleBar from "simplebar-react";

interface Props {
  children?: any;
  classes: any;
  toggleMenu: () => void;
  isOpen: boolean; //Determins if the sidebar is open and class composition for elements
  clearAllClick: () => void;
  clearAllHidden?: boolean;
  sideBarWidth?: number; //This will only be consumed in Reactjss, and used in computing a value for translateX
  showSidebar?: boolean;
  showError?: boolean;
  error?: string;
}

type SideBar<Props> = FC<Props> & {
  SideBarContent?: React.ReactNode;
  MainContent?: React.ReactNode;
};

const sidebar: SideBar<Props> = props => {
  const styles = {
    zIndex: 10,
    height: "calc(100vh - 110px)",
    overflowX: "hidden",    
    backgroundColor: "#fff",
    width: (props.isOpen && "331px") || "60px",
    transition: "all 600ms",
    transitionTimingFunction: "cubic-bezier(.28,.73,.38,1.02)",
    borderRight: "1px solid #F1F1F3",
    position: "relative"
  };

  return (
    <div className={props.classes.container}>
      {/* SideBar */}
      <div
        className={classNames(props.classes.sideBarHider, {
          [props.classes.sideBarHiderClosed]: !props.isOpen
        })}
      >
        <SimpleBar className={props.classes.simplebar} style={styles}>
          <div
            className={classNames(props.classes.sideBar, {
              [props.classes.sideBarClosed]: !props.isOpen
            })}
          >
            <div className={props.classes.fixedHeaderContainer}>
              <div className={props.classes.header}>
                <div
                  className={props.classes.funnel}
                  onClick={props.toggleMenu}
                >
                  <Funnel />
                </div>
                <span className={props.classes.title}>Filters</span>
                {!props.clearAllHidden && (
                  <button
                    aria-label={"Reset"}
                    onClick={props.clearAllClick}
                    className={props.classes.clearAllButton}
                  >
                    Reset
                  </button>
                )}
                <button
                  aria-label={props.isOpen ? "close filters" : "open filters"}
                  onClick={props.toggleMenu}
                  className={props.classes.iconHolder}
                >
                  {!props.isOpen && (
                    <Funnel className={props.classes.funnelIcon} />
                  )}
                  {props.isOpen && <Arrow className={props.classes.arrow} />}
                </button>
              </div>
              <div
                className={`${props.classes.error} ${!props.showError &&
                  props.classes.hidden}`}
              >
                {props.error}
              </div>
            </div>
            <div className={props.classes.sideBarChild}>
              {props.children[0]}
            </div>
          </div>
        </SimpleBar>
      </div>

      {/* Main Content */}
      <div className={props.classes.mainContent}>{props.children[1]}</div>
    </div>
  );
};

sidebar.SideBarContent = SideBarContent;
sidebar.MainContent = MainContent;
export const SideBar = injectSheet(styleSheet)(sidebar);
